import { service } from "../utils/request";

//门店列表
export function storeList(data) {
  return service({
    url: "offlinestore/agent.store/index",
    method: "post",
    data: data
  });
}
//门店下拉列表数据
export function selectStoreList(data) {
  return service({
    url: "offlinestore/agent.store/roomSelect",
    method: "post",
    data: data
  });
}

//添加门店
export function storeAdd(data) {
  return service({
    url: "offlinestore/agent.store/add",
    method: "post",
    data: data
  });
}

//修改门店
export function storeEdit(data) {
  return service({
    url: "offlinestore/agent.store/edit",
    method: "post",
    data: data
  });
}

//删除门店
export function storeDelete(data) {
  return service({
    url: "offlinestore/agent.store/del",
    method: "post",
    data: data
  });
}

//门店详情
export function storeDetail(data) {
  return service({
    url: "offlinestore/agent.store/detail",
    method: "post",
    data: data
  });
}

//门店选择列表
export function storeSelect(data) {
  return service({
    url: "offlinestore/agent.store/roomSelect",
    method: "post",
    data: data
  });
}

//店铺列表 多商户返回200列表 单商户返回400
export function allStore(data) {
  return service({
    url: "merch/agent.merch/merchStore",
    method: "post",
    data: data
  });
}
// 门店服务
export function storeServeList(data) {
  return service({
    url: "/offlinestore/agent.Offline_Store_Service/index",
    method: "post",
    data: data
  });
}
export function storeServeAdd(data) {
  return service({
    url: "/offlinestore/agent.Offline_Store_Service/add",
    method: "post",
    data: data
  });
}
export function storeServeDel(data) {
  return service({
    url: "/offlinestore/agent.Offline_Store_Service/del",
    method: "post",
    data: data
  });
}
